<script lang="ts">
  import NoSubscriptionUserTopBarPage from '../../Navigation/TopLevelPages/NoSubscriptionUserTopBarPage.svelte'
  import { sendEventToFirebase } from '../../logging/events'
  import { onMount } from 'svelte'
  onMount(() => {
    sendEventToFirebase({ key: 'CancelledCheckout' })
  })
</script>

<NoSubscriptionUserTopBarPage>
  <p>
    We're sorry that you didn't Sign Up. If you would like to try out the app in the future, just visit the <a
      href="/">Sign Up page</a
    >.
  </p>
</NoSubscriptionUserTopBarPage>
